import { NgModule } from '@angular/core';
import { CustomProductPageEventBuilder } from './custom-product-page-event.builder';

@NgModule({})
export class CustomProductPageEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customProductPageEventBuilder: CustomProductPageEventBuilder) {}
}
